/**
 * Centralised company info. Update here and it propagates across all legal pages.
 */
export const company = {
  name: 'QOthers',
  brand: 'CasaOthers',
  kvk: '80316689',
  vestigingsnummer: '000046678859',
  legalForm: 'Eenmanszaak',
  street: 'Van Yrtebelt 24',
  postalCity: '8014 NM Zwolle',
  country: 'Nederland',
  email: 'info@casaothers.nl',
  whatsapp: '+31 6 44 87 94 15',
  whatsappUrl: 'https://wa.me/31644879415',
  website: 'https://casaothers.nl',
  effectiveDate: '7 mei 2026',
};

export default company;
